/** Routes that exist only during an OIDC exchange: never navigate "back" to one, never open a modal over one. */
export const AUTH_CALLBACK_ROUTES: readonly string[] = ['/signin-callback', '/signout-callback'];

export function isAuthCallbackUrl(url: string): boolean {
  return AUTH_CALLBACK_ROUTES.some(route => url.startsWith(route));
}
